export interface UrlNameAvailability {
  isAvailable: boolean;
}
